import React from "react";
import {
  ItemColor,
  ItemFont,
  ItemFontStyle,
  ItemFontSize,
  ItemLineHeight,
  ItemMargin,
  ItemPadding,
  ItemBorderStyle,
  ItemBorderWidth,
  ItemBorderRadius,
  ItemCSS,
} from "../Elements";

export const BlockquoteElement = (props) => {
  const {
    sections,
    borderStyles,
    findFontVal,
    findFontVariants,
    findColorVal,
    findStyleVal,
    updateColor,
    updateFont,
    updateWeight,
    updateStyle,
    toggleCSS,
    toggleSection,
    item: { elements, fonts, palette },
  } = props;

  const defaultProps = {
    elements: elements,
    updateStyle: updateStyle,
  };

  const fontProps = {
    fonts: fonts,
    elements: elements,
    findFontVal: findFontVal,
    updateFont: updateFont,
  };

  const fontStyleProps = {
    elements: elements,
    findFontVal: findFontVal,
    findFontVariants: findFontVariants,
    updateWeight: updateWeight,
  };

  const colorProps = {
    elements: elements,
    palette: palette,
    findColorVal: findColorVal,
    updateColor: updateColor,
  };

  const borderProps = {
    elements: elements,
    updateStyle: updateStyle,
    borderStyles: borderStyles,
  };

  return (
    <div
      id="blockquote-element"
      className={`element element-blockquote ${
        sections.blockquote.active ? "active" : ""
      } ${sections.blockquote.css ? "css" : ""} ${
        elements.blockquote.disabled ? "disabled" : ""
      }`}
    >
      <div
        className="element-content"
        onClick={() => toggleSection("blockquote", true)}
      >
        <div className="text-group">
          <blockquote
            style={{
              background: findColorVal("blockquote", "background"),
              borderColor: findColorVal("blockquote", "borderColor"),
              borderRadius: elements.blockquote.borderRadius,
              borderStyle: elements.blockquote.borderStyle,
              borderWidth: elements.blockquote.borderWidth,
              boxShadow: elements.blockquote.boxShadow,
              color: findColorVal("blockquote", "color"),
              fontFamily: findFontVal("blockquote", "fontFamily"),
              fontSize: elements.blockquote.fontSize,
              fontStyle: elements.blockquote.fontStyle,
              fontWeight: elements.blockquote.fontWeight,
              lineHeight: elements.blockquote.lineHeight,
              margin: elements.blockquote.margin,
              padding: elements.blockquote.padding,
            }}
          >
            <strong>Blockquote: </strong>
            If you can dream—and not make dreams your master; If you can
            think—and not make thoughts your aim; If you can meet with Triumph
            and Disaster And treat those two impostors just the same;
          </blockquote>
        </div>
      </div>
      {sections.blockquote.active ? (
        <div className="edit-element">
          <div className="edit-item edit-parent">
            <label>Blockquote font, styles, and colors</label>

            <div className="edit-item-sub">
              <ItemFont item={"blockquote"} {...fontProps} />

              <ItemFontStyle item={"blockquote"} {...fontStyleProps} />

              <ItemFontSize item={"blockquote"} {...defaultProps} />

              <ItemLineHeight item={"blockquote"} {...defaultProps} />

              <ItemColor
                type="color"
                item="blockquote"
                label="font color"
                {...colorProps}
              />
            </div>

            <div className="edit-item-sub">
              <ItemMargin item="blockquote" {...defaultProps} />

              <ItemPadding item="blockquote" {...defaultProps} />

              <ItemColor
                type="background"
                item="blockquote"
                label="bg color"
                {...colorProps}
              />
            </div>

            <div className="edit-item-sub">
              <ItemBorderStyle item="blockquote" {...borderProps} />

              <ItemBorderWidth item="blockquote" {...defaultProps} />

              <ItemBorderRadius item="blockquote" {...defaultProps} />

              <ItemColor
                type="borderColor"
                item="blockquote"
                label="border color"
                {...colorProps}
              />
            </div>
          </div>
        </div>
      ) : null}
      {sections.blockquote.active ? (
        <div
          className="edit-element-btn"
          onClick={() => toggleCSS("blockquote")}
        >
          <span>{sections.blockquote.css ? "hide" : "show"} css</span>
        </div>
      ) : null}
      {sections.blockquote.css ? (
        <div className="edit-element-css">
          <div className="element-css">
            <ItemCSS
              item={elements.blockquote}
              label={`blockquote`}
              findStyleVal={findStyleVal}
            />
          </div>
        </div>
      ) : null}

      <div className="card-edit-wrap">
        <span className="card-edit" onClick={() => toggleSection("blockquote")}>
          <i className="icon icon-edit" />
        </span>
      </div>
    </div>
  );
};
